var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top-nav',[_c('template',{slot:"nav"},[_c('top-nav-sub')],1),_c('template',{slot:"content"},[_c('top-nav-content')],1)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }